import { withNamespaces } from "react-i18next";
import { useEffect } from "react";
import { Prompt } from "react-router-dom";
import { connect } from "react-redux";
import {
    confirmPromptUpdateConfirmStatus
} from 'src/store/actions';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const useBeforeUnload = ({ when, message }) => {
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (when) {
                event.preventDefault();
                event.returnValue = message;
                return message;
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [when, message]);
};

export const ConfirmPrompt = ({
    promptOptions,
    updateConfirmPromptConfirmStatus
}) => {
    useBeforeUnload({
        when    :   promptOptions.readyToShow,
        message :   promptOptions.message
    });

    const {
        buttons
    } = promptOptions;

    return (
        <>
            <Modal isOpen={ promptOptions.readyToShow && promptOptions.show }>
                {
                    promptOptions?.title && (
                        <ModalHeader>
                            { promptOptions.title }
                        </ModalHeader>
                    )
                }

                <ModalBody>
                    {promptOptions?.message ? promptOptions.message : null}
                </ModalBody>
                
                {buttons && (
                    <ModalFooter>
                        {buttons({ updateConfirmPromptConfirmStatus })}
                    </ModalFooter>
                )}
            </Modal>

            <Prompt     
                message="Changes you made may not be saved." 
                when={ promptOptions.readyToShow } 
            />
        </>
    )
}

const mapStatetoProps = (state) => {
    return {
        promptOptions   :   state.ExitConfirmPrompt
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps,
        {
            updateConfirmPromptConfirmStatus    :   (status) =>  confirmPromptUpdateConfirmStatus(status)
        }
    )(ConfirmPrompt)
);